<template>
  <Typo>
    <p class="mb-0 text-center">
      {{ $t('Nie sú dostupné žiadne dokumenty.') }}
    </p>
  </Typo>
</template>
